import { render, staticRenderFns } from "./batchProductList.vue?vue&type=template&id=67e86687"
import script from "./batchProductList.vue?vue&type=script&lang=js"
export * from "./batchProductList.vue?vue&type=script&lang=js"
import style0 from "./batchProductList.vue?vue&type=style&index=0&id=67e86687&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports